import generalEn from '$lib/i18n/locales/en/generalEN.json';
import shopEn from '$lib/i18n/locales/en/shopEN.json';
import accountEn from '$lib/i18n/locales/en/accountEN.json';
import checkoutEn from '$lib/i18n/locales/en/checkoutEN.json';
import errorEn from '$lib/i18n/locales/en/errorEN.json';

export default {
    localeName: 'English',
    localeIdentifier: 'en-US',
    general: generalEn,
    shop: shopEn,
    account: accountEn,
    checkout: checkoutEn,
    error: errorEn
};
